import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/** which panel the compositor's side column is showing */
export type CompositorPanel = 'layers' | 'assets';

export const COMPOSITOR_PANEL: Record<CompositorPanel, CompositorPanel> = {
  layers: 'layers',
  assets: 'assets',
};

interface EditorState {
  clearNodeId: () => void;
  nodeId: string | null;
  isEditorOpen: boolean;
  onClose: () => void;
  openEditor: (nodeId: string) => void;
  /** lives here because the icons that switch it sit in the editor's toolbar column */
  compositorPanel: CompositorPanel;
  setCompositorPanel: (panel: CompositorPanel) => void;
}

export const useEditorStore = create<EditorState>()(
  devtools(
    (set) => ({
      // Initial state
      clearNodeId: () => set(() => ({ nodeId: null })),
      nodeId: null,
      isEditorOpen: false,
      onClose: () => set(() => ({ isEditorOpen: false })),
      // reset on open, so every compositor starts on its layers
      openEditor: (nodeId: string) => set({ nodeId, isEditorOpen: true, compositorPanel: COMPOSITOR_PANEL.layers }),
      compositorPanel: COMPOSITOR_PANEL.layers,
      setCompositorPanel: (compositorPanel: CompositorPanel) => set(() => ({ compositorPanel })),
    }),
    {
      name: 'Editor Store',
      enabled: import.meta.env.DEV,
    },
  ),
);
